import { call, put, takeLatest } from "redux-saga/effects";
import { callConfigGetApi } from "../Context/configApi";
import { onGetApiConfig, onGetApiConfigError, onGetApiConfigSuccess } from "../Store/Slices/apiConfigSlice";

function* GetApiConfig({payload}) {
  try {
    const getApiConfigResponse = yield call(callConfigGetApi,payload);

    if (getApiConfigResponse.httpStatusCode === "200") {
      yield put(
        onGetApiConfigSuccess({
          data: getApiConfigResponse.response,
          message: getApiConfigResponse.errorMessage,
          status_code: getApiConfigResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetApiConfigError({
          data: getApiConfigResponse.response,
          message: getApiConfigResponse.errorMessage,
          status_code: getApiConfigResponse.httpStatusCode,
        })
      );
    }
  } catch (error) { 
    const message = error.message || "Something went wrong";
    yield put(onGetApiConfigError({ data: {}, message, status_code: error.response.status }));
  }
}

export default function* apiConfigSaga() {
  yield takeLatest(onGetApiConfig.type, GetApiConfig);
}
